// 抽屉型聚合列表
// https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png
const drawerList = {
  data: {
    content: {
      type: 14,
      tit: '请选择您要咨询的订单-5抽屉聚合',
      templateId: 5,
      tabCount: 4,
      pageSize: 8,
      contentData: {
        tab: [
          {
            tabName: '已签收的 1',
            tabId: 1,
          },
          {
            tabName: '已签收的2',
            tabId: 2,
          },
          {
            tabName: '已签收的3',
            tabId: 3,
          },
          {
            tabName: '已签收的 4',
            tabId: 4,
          },
        ],
        currentPage: 1,
        currentTabId: 1,
        hasNext: true,
        contentList: [
          {
            id: 0,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            name: '抽屉聚合1',
            status: '2021- 04-14',
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合11',
                des: '这个手 机',
                mon: '99.99',
                count: 1,
                much: '2567',
                isLink: false,
              },
            ],
          },
          {
            id: 1,
            name: '抽屉聚合 2',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04- 14',
            dot: 2,
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合 21',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
                dot: 2,
              },
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合 22',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
                dot: 2,
              },
            ],
          },
          {
            id: 2,
            name: '抽屉聚合3',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04- 14',
            dot: 2,
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合 31',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
                dot: 2,
              },
            ],
          },
          {
            id: 3,
            name: '抽屉聚合4',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04- 14',
            dot: 2,
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合 41',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
                dot: 2,
              },
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '抽屉聚合 42',
                isLink: false,
                des: '这个手 机',
                mon: '99.99',
                count: 1,
                much: '2567',
                dot: 2,
              },
            ],
          },
        ],
      },
      questionId: 1234,
      domain: 'abcd',
      intent: 'ehig',
    },
    type: 7,
  },
};
// 抽屉不聚合
const  drawerNoGroupList = {
  data: {
    content: {
      type: 14,
      tit: '请选择您要咨询的订单-2抽屉不聚 合',
      templateId: 2,
      tabCount: 4,
      pageSize: 8,
      questionId: 1234,
      domain: 'abcd',
      intent: 'ehig',
      contentData: {
        tab: [
          {
            tabName: '已签收的 1',
            tabId: 1,
          },
          {
            tabName: '已签收的2',
            tabId: 2,
          },
          {
            tabName: '已签收的3',
            tabId: 3,
          },
          {
            tabName: '已签收的4',
            tabId: 4,
          },
          {
            tabName: '已签收的5',
            tabId: 1,
          },
          {
            tabName: '已签收的 6',
            tabId: 2,
          },
          {
            tabName: '已签收的7',
            tabId: 3,
          },
          {
            tabName: '已签收的8',
            tabId: 4,
          },
          {
            tabName: '已签收的9',
            tabId: 3,
          },
          {
            tabName: '已签收的 10',
            tabId: 4,
          },
        ],
        currentPage: 1,
        currentTabId: 1,
        hasNext: true,
        contentList: [
          {
            itemId: 111,
            logo: '',
            // tit: '抽屉不聚合 1',
            isLink: false,
            des: '这个手机',
            // mon: '99.99',
            count: null,
            much: null,
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '抽屉不聚合 2',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '抽屉不聚合 3',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '抽屉不聚合 4',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '抽屉不聚合 5',
            isLink: false,
            des: '这个手机这个手机这个手机这个手机这个手机这个手 机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
        ],
      },
    },
    type: 7,
  },
};
// 气泡聚合型
const bubbleList = {
  data: {
    content: {
      type: 14,
      questionId: 1234,
      domain: 'abcd',
      intent: 'ehig',
      tit: '请选择您要咨询的订单-1气泡聚合型',
      templateId: 4,
      tabCount: 4,
      pageSize: 8,
      contentData: {
        currentPage: 1,
        hasNext: true,
        contentList: [
          {
            id: 1,
            name: '气泡聚合 1',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04-14',
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '气泡聚合 11',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
              },
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '气泡聚合 12',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
              },
            ],
          },
          {
            id: 2,
            name: '气泡聚合2',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04-14',
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '气泡聚合 21',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
              },
            ],
          },
          {
            id: 3,
            name: '气泡聚合3',
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            status: '2021-04-14',
            subList: [
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '气泡聚合 31',
                isLink: false,
                des: '这个手机',
                mon: '99.99',
                count: 1,
                much: '2567',
              },
              {
                itemId: 111,
                logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
                tit: '气泡聚合 32',
                isLink: false,
                des: '这个手 机',
                mon: '99.99',
                count: 1,
                much: '2567',
              },
            ],
          },
        ],
      },
    },
    type: 7,
  },
};

// 气泡不聚会型

const bubbleNoGroupList = {
  data: {
    content: {
      questionId: 1234,
      domain: 'abcd',
      intent: 'ehig',
      type: 14,
      tit: '请选择您要咨询的订单-1气泡 型',
      templateId: 1,
      tabCount: 4,
      pageSize: 8,
      contentData: {
        currentPage: 1,
        hasNext: true,
        contentList: [
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '气泡不聚合 1',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '气泡不聚合 2',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '气泡不聚合 3',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '气泡不聚合 4',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '气泡不聚合 5',
            isLink: false,
            des: '这个手机这个手机这个手机这个手机这个手机这个手 机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
        ],
      },
    },
    type: 7,
  },
};
// 横滑卡片型
const cardList = {
  data: {
    type: 7,
    content: {
      questionId: 1234,
      domain: 'abcd',
      intent: 'ehig',
      type: 14,
      tit: '请选择您要咨询的订单-3横划卡片型',
      templateId: 3,
      pageSize: 8,
      contentData: {
        currentPage: 1,
        hasNext: true,
        contentList: [
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 1',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 2',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 3',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 4',
            isLink: false,
            des: '这个手机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 5',
            isLink: false,
            des: '这个手机这个手机这个手机这个手机这个手机这个手 机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
          {
            itemId: 111,
            logo: 'https://cdn-we-retail.ym.tencent.com/tsr/goods/dz-3a.png',
            tit: '卡片型 6',
            isLink: false,
            des: '这个手机这个手机这个手机这个手机这个手机这个手 机',
            mon: '99.99',
            count: 1,
            much: '2567',
          },
        ],
      },
    },
  },
};
// 物流节点型
const nodeList = {
  data: {
    type: 7,
    content: {
      type: 16,
      content: {
        title: '北京->上 海',
        subTitledesc: 'xx快递:267384905-67',
        list: [{
          name: '您的快件在上海市徐汇区田林路中环国际 广场C座，前台已签收',
          desc: '01-20 20:00',
          status: 1,
        },
        {
          name: '您的快件在上海市徐汇区田林路中环国际 广场C座，前台已签收',
          desc: '01-20 20:00',
          status: 1,
        },
        {
          name: '您的快件在上海市徐汇区田林路中环国际 广场C座，前台已签收',
          desc: '01-20 20:00',
          status: 1,
        },
        {
          name: '您的快件在上海市徐汇区田林路中环国际 广场C座，前台已签收',
          desc: '01-20 20:00',
          status: 1,
        },
        {
          name: '您的快件在上海市徐汇区田林路中环国际 广场C座，前台已签收',
          desc: '01-20 20:00',
          status: 1,
        },
        ],
      },
    },
  },
};
export {
  drawerList,
  bubbleList,
  cardList,
  nodeList,
  drawerNoGroupList,
  bubbleNoGroupList,
};
